import { useState, useEffect, useContext } from 'react';
import { DiilHeaderContext } from './DiilHeader';
import { getPublicApiUrl, getTeliaSelfServiceUrl } from './EnvironmentUrls';
import { fetchJson } from './JSONController';
const menuCodeEmployee = 'EMPLOYEE';
const EmployeeMenuItemsProvider = () => {
    const { sso, environment, brand } = useContext(DiilHeaderContext);
    const [employeeMenuItems, setEmployeeMenuItems] = useState([]);
    useEffect(() => {
        if (sso.dealer) {
            getEmployeeMenuItems();
        }
    }, [sso.dealer]);
    const getEmployeeMenuItems = async () => {
        const { items } = await fetchJson(`${getPublicApiUrl(environment, brand)}/menu/header/et/code/${menuCodeEmployee}?app=${brand}`);
        setEmployeeMenuItems(createNavTree(items));
    };
    const createNavTree = (list) => {
        if (!list) {
            return null;
        }
        return list.map((item) => {
            const url = item.url.startsWith('http') ? item.url : `${getTeliaSelfServiceUrl(environment)}${item.url}`;
            return {
                label: item.label,
                url
            };
        });
    };
    return { employeeMenuItems };
};
export default EmployeeMenuItemsProvider;
//# sourceMappingURL=EmployeeMenuItemsProvider.js.map